import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { Referentiel } from 'src/app/data/declaration/models/referentiel.model';
import { SaisieRevendication } from 'src/app/data/declaration/models/saisie-revendication.model';
import { MouvementsProduitsService } from 'src/app/data/declaration/services/mouvements/mouvements-produits.service';
import { ReferentielService } from 'src/app/data/declaration/services/referentiel/referentiel.service';

@Component({
    selector: 'app-vue-revendication',
    templateUrl: './vue-revendication.component.html',
    styleUrls: ['./vue-revendication.component.scss'],
    standalone: false
})
export class VueRevendicationComponent implements OnInit {
    /**
     * Id mouvement
     */
    @Input() idMouvement: number;

    /**
     * Id operateur
     */
    @Input() public idOperateur: number;

    /**
     * Revendication
     */
    revendication: SaisieRevendication;

    /**
     * Référentiel
     */
    public referentiel: Referentiel;

    constructor(
        public readonly modal: NgbActiveModal,
        private readonly referentielService: ReferentielService,
        private readonly mouvementsProduitsService: MouvementsProduitsService
    ) {}

    /**
     * On init component
     */
    ngOnInit() {
        this.loadData();
    }

    /**
     * Charge la liste des mouvements non lus et le référentiel
     */
    private loadData() {
        forkJoin([this.mouvementsProduitsService.getRevendication(this.idOperateur, this.idMouvement), this.referentielService.getReferentiel()])
            .pipe()
            .subscribe(([revendication, referentiel]) => {
                this.revendication = revendication;
                this.referentiel = referentiel;
            });
    }

    /**
     * Ferme la modale
     */
    public onClose(): void {
        this.modal.dismiss();
    }

    /**
     * Get cépage labelles
     * @param cepages - Liste des cépages
     */
    public getCepages(cepages: number[]): string {
        if (cepages.length > 0) {
            return this.referentiel.cepages
                .filter(cepage => cepages.find(c => c === cepage.id))
                .map(cepage => cepage.libelle)
                .join(', ');
        }
        return '';
    }

    /**
     * Get destinations labelles
     * @param destinations - Liste des destinations
     */
    public getDestinations(destinations: number[]): string {
        if (destinations.length > 0) {
            return this.referentiel.mouvementsDestinations
                .filter(destination => destinations.find(d => d === destination.id))
                .map(destination => destination.libelle)
                .join(', ');
        }
        return '';
    }

    /**
     * Get environnement labelles
     * @param labels - Liste des environnements labels
     */
    getEnvironnementLabels(labels: number[]): string {
        if (labels.length > 0) {
            return this.referentiel.environnementLabels
                .filter(label => labels.find(l => l === label.id))
                .map(label => label.libelle)
                .join(', ');
        }
        return '';
    }
}
